import {connect} from 'react-redux'
import withRouter from "../../../components/RouterComponentWrapper";
import TurnierKratzerDetail from "../../../components/views/liga/TurnierKratzerDetail";

const mapStateToProps = function (state, ownProps) {
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    const turnierId = urlParams.get('turnierid');
    return {turnierid: turnierId, userId: state.user.id};
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TurnierKratzerDetail))
